export const customEventConstants = {
    CUSTOM_EVENT_LOADING_SPINNER: 'CUSTOM_EVENT_LOADING_SPINNER',
    CUSTOM_EVENT_STOP_LOADING_SPINNER: 'CUSTOM_EVENT_STOP_LOADING_SPINNER',
    CUSTOM_EVENT_RERENDER: 'CUSTOM_EVENT_RERENDER',
    CUSTOM_EVENT_GET_DATA: 'CUSTOM_EVENT_GET_DATA',
    CUSTOM_EVENT_ARCHIVE: 'CUSTOM_EVENT_ARCHIVE',
    CUSTOM_EVENT_RESTORE: 'CUSTOM_EVENT_RESTORE',
};